import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

export interface SecondaryButtonProps {
  children?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  icon?: ReactNode;
  darkBg?: boolean;
  customClassName?: string;
  fullWidth?: boolean;
  tabIndex?: number;
  isLoading?: boolean;
  trackingId?: string;
  tradeInWidget?: boolean;
}

const SecondaryButton: FC<SecondaryButtonProps> = (
  props: SecondaryButtonProps
) => {
  const {
    children,
    onClick,
    icon,
    disabled = false,
    darkBg = false,
    customClassName,
    fullWidth = false,
    tabIndex,
    trackingId,
    isLoading = false,
    ...restProps
  } = props;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabIndex || 0}
      data-tracking-id={trackingId}
      className={clsx(
        'align-middle border-1px font-weight-bold h-[50px] inline-flex items-center justify-center rounded-default shadow-sm focus:ring-inset',
        fullWidth && 'w-full',

        darkBg &&
          'disabled:bg-purple90 disabled:border-purple90 disabled:text-grey100 monochrome:disabled:bg-grey90 monochrome:disabled:border-grey90 monochrome:disabled:text-grey10',
        !darkBg && 'disabled:bg-grey30 disabled:border-grey30',

        darkBg &&
          'text-purple80 bg-grey10 border-white hover:bg-grey20 hover:border-grey20 monochrome:text-grey90 monochrome:bg-white',

        !darkBg &&
          'aurego-color2 border-purple70 bg-purple80 hover:bg-purple90 hover:border-purple90 text-white monochrome:border-grey90 monochrome:bg-black monochrome:hover:bg-grey80 monochrome:hover:border-grey80',
        {
          'px-40px': icon === undefined,
          'px-[14px]': icon !== undefined,
        },
        isLoading &&
          disabled &&
          'disabled:bg-purple80 disabled:border-purple70 monochrome:disabled:bg-black monochrome:disabled:border-grey90',

        customClassName
      )}
      {...restProps}
    >
      {icon}
      {children}
    </button>
  );
};

export default SecondaryButton;
